import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '~/shadcn/ui/dialog'
import { _killPropagation } from '~/@lib/utils/ui.utils'
import type {
  ProjectSchema,
  ProjectsItem,
} from '~/@pages_investing/projects/_project_types/project.types'

import { ProjectPopupTop } from './ProjectPopupTop'
import { ProjectPopupBottom } from './ProjectPopupBottom'

type Props = {
  project: ProjectSchema | ProjectsItem
  isOpen: boolean
  handleClosePopup: (
    e?: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void
}

function ProjectPopup({ project, isOpen, handleClosePopup }: Props) {
  return (
    <Dialog open={isOpen} onOpenChange={() => handleClosePopup()}>
      <DialogTitle title={`Popis projektu ${project.location}`} />
      <DialogContent
        onClick={_killPropagation}
        className="bg-background p-0 overflow-hidden overflow-y-auto">
        <DialogDescription title={`Popis projektu ${project.location}`} />
        <DialogHeader className="flex justify-end h-6" />
        <ProjectPopupTop project={project} />
        <ProjectPopupBottom project={project} />
      </DialogContent>
    </Dialog>
  )
}

export { ProjectPopup }
